import BusinessRoutePath from 'app/business-app/BusinessRoutePath';
import { CreateCompanyReq } from 'app/core/api/company/api-company.types';
import {
  patchStoredObject,
  retrieveStoredItem,
  storeItem,
} from 'app/tools/hooks/local-storage/local-storage-methods';
import { LSKey } from 'app/tools/hooks/local-storage/local-storage.types';
import { useUrlRouteMatch } from 'app/tools/hooks/misc-hooks';
import _ from 'lodash';
import { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { Except } from 'type-fest';

type PartialCreateCompanyReqJsonSafe = Except<
  Partial<CreateCompanyReq>,
  'logo'
>;

const getBusinessProfileTemp = () =>
  retrieveStoredItem<PartialCreateCompanyReqJsonSafe>(
    LSKey.BUSINESS_PROFILE_TEMP
  ) || {};

export const patchBusinessProfileTemp = (
  profileUpdate: PartialCreateCompanyReqJsonSafe
): PartialCreateCompanyReqJsonSafe =>
  patchStoredObject<Except<CreateCompanyReq, 'logo'>>(
    LSKey.BUSINESS_PROFILE_TEMP,
    profileUpdate
  );

export const clearBusinessProfileTempKeys = (
  keysToClear: string[]
): void => {
  const currentProfileTemp = getBusinessProfileTemp();
  const clearedProfileTemp = _.omit(currentProfileTemp, keysToClear);
  storeItem<PartialCreateCompanyReqJsonSafe>(
    LSKey.BUSINESS_PROFILE_TEMP,
    clearedProfileTemp
  );
};

export const useGetBusinessProfileTempOnce =
  (): PartialCreateCompanyReqJsonSafe =>
    useMemo(getBusinessProfileTemp, []);

type MovePageHook = {
  nextPage: (isIndividual?: boolean) => void;
  prevPage: (isIndividual?: boolean) => void;
};
export const useMovePage = (): MovePageHook => {
  const history = useHistory();
  const isUpdatePage = Boolean(history.location.state);
  const { params } = useUrlRouteMatch();
  const pageNum = Number(params.pageNum ?? 0);
  return {
    nextPage: (isIndividual?: boolean) =>
      history.push(
        isUpdatePage
          ? BusinessRoutePath.PROFILE
          : isIndividual
          ? `${BusinessRoutePath.CREATE_PERSONAL_PROFILE_PAGE}/${
              pageNum + 1
            }`
          : `${BusinessRoutePath.CREATE_PROFILE_PAGE}/${pageNum + 1}`
      ),
    prevPage: (isIndividual?: boolean) =>
      history.push(
        isIndividual
          ? `${BusinessRoutePath.CREATE_PERSONAL_PROFILE_PAGE}/${
              pageNum - 1
            }`
          : `${BusinessRoutePath.CREATE_PROFILE_PAGE}/${pageNum - 1}`
      ),
  };
};
